import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BenefitsSection() {
  return <section className="py-12 mb-12" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-30">
          Lo Que Vas a Lograr
        </h2>
        <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-31">
          Lo Que Vas a Lograr con Este Curso
        </p>
        <div className="space-y-4 mb-8" data-id="element-32">
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-33">
            <div className="text-amber-600 mt-1" data-id="element-34">
              <CheckCircleIcon size={20} data-id="element-35" />
            </div>
            <p className="text-gray-700" data-id="element-36">
              Preparar una milhojas clásica Uruguaya con capas finas y
              crocantes.
            </p>
          </div>
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-37">
            <div className="text-amber-600 mt-1" data-id="element-38">
              <CheckCircleIcon size={20} data-id="element-39" />
            </div>
            <p className="text-gray-700" data-id="element-40">
              Rellenar con dulce de leche en la textura justa para que la torta
              quede alta y firme.
            </p>
          </div>
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-41">
            <div className="text-amber-600 mt-1" data-id="element-42">
              <CheckCircleIcon size={20} data-id="element-43" />
            </div>
            <p className="text-gray-700" data-id="element-44">
              Decorar con un merengue italiano brillante, firme y delicioso.
            </p>
          </div>
          <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-45">
            <div className="text-amber-600 mt-1" data-id="element-46">
              <CheckCircleIcon size={20} data-id="element-47" />
            </div>
            <p className="text-gray-700" data-id="element-48">
              Sorprender a tu familia, amigos o clientes con un postre digno de
              pastelería profesional.
            </p>
          </div>
        </div>
      </div>
    </section>;
}